export default __webpack_public_path__ + "static/media/pristyn-benefit-icon.1b1ee9e0.png";